import React, { useState } from 'react';
import { Button, Modal, ListGroup } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import moment from 'moment';
import { schedulesService } from '../../services';
import { getUserData } from '../../helpers';

const ScheduleRequests = ({
  handleReFetchEvents,
  handleLoader,
  isLoading,
  availableSlots,
  handleGetSlots,
}) => {
  const [show, setShow] = useState(false);

  const handleRequest = (requestId) => {
    const params = {
      teamOwnerId: localStorage.getItem('teamOwnerId'),
      slotId: requestId,
      teamMemberId: getUserData('_id'),
    };

    handleLoader(true);
    schedulesService
      .apply_overtime_slot(params)
      .then((response) => {
        if (response.status) {
          handleGetSlots();
          handleReFetchEvents(true);
          setShow(false);
          toast.success('Overtime slot apply request successfully submitted.');
        }
      })
      .catch((error) => {
        if (error.message) {
          toast.error(error.message);
        }
      })
      .finally(() => {
        handleLoader(false);
      });
  };

  const handleRequestForCreateSchedule = (requestData) => {
    const params = {
      teamOwnerId: localStorage.getItem('teamOwnerId'),
      scheduleId: requestData.scheduleId,
      accept: requestData.status,
      note: '',
    };
    handleLoader(true);
    schedulesService
      .process_request(params)
      .then((response) => {
        if (response.status) {
          handleGetSlots();
          handleReFetchEvents(true);
          setShow(false);
          toast.success(
            requestData.status
              ? 'Overtime request accepted successfully.'
              : 'Overtime request rejected successfully.'
          );
        }
      })
      .catch((error) => {
        if (error.message) {
          toast.error(error.message);
        }
      })
      .finally(() => {
        handleLoader(false);
      });
  };
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <Button
        onClick={handleShow}
        variant="white"
        className="position-relative"
      >
        Available overtime slots
        <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
          {availableSlots.length}
        </span>
      </Button>
      <Modal
        show={show}
        onHide={handleClose}
        centered
        style={{ maxHeight: 'calc(100vh - 210px)', overflowY: 'auto' }}
      >
        <Modal.Header className="pt-4" closeButton>
          <Modal.Title>Open Slots</Modal.Title>
        </Modal.Header>
        <Modal.Body
          className="overflow-auto"
          style={{ maxHeight: 'calc(100vh - 100px)' }}
        >
          {availableSlots.length === 0 && !isLoading ? (
            <p className="text-muted text-center">No open slots available.</p>
          ) : (
            <ListGroup>
              {availableSlots.map((req, idx) => {
                const isSchedule = req.isFromCreateSchedule;
                const start = isSchedule ? req.shiftStart : req.otStartTz;
                const end = isSchedule ? req.shiftEnd : req.otEndTz;
                return (
                  <ListGroup.Item
                    key={idx}
                    className="d-flex justify-content-between align-items-center"
                  >
                    <div className="ms-2 me-auto">
                      <div>
                        On {moment.utc(start).format('dddd, MMMM D, YYYY')}{' '}
                        <br />
                        From {moment.utc(start).format('hh:mm A')} to{' '}
                        {moment.utc(end).format('hh:mm A')}
                      </div>
                    </div>
                    <>
                      {isSchedule ? (
                        req.isApprovalPending && (
                          <Button
                            variant="primary"
                            size="sm"
                            className="me-2"
                            onClick={() =>
                              handleRequestForCreateSchedule({
                                scheduleId: req._id,
                                status: true,
                              })
                            }
                          >
                            Apply
                          </Button>
                        )
                      ) : (
                        <Button
                          variant="primary"
                          size="sm"
                          className="me-2"
                          onClick={() => handleRequest(req._id)}
                        >
                          Apply
                        </Button>
                      )}
                    </>
                  </ListGroup.Item>
                );
              })}
            </ListGroup>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

ScheduleRequests.propTypes = {
  handleReFetchEvents: PropTypes.func,
  handleLoader: PropTypes.func,
  isLoading: PropTypes.bool,
  availableSlots: PropTypes.array,
  handleGetSlots: PropTypes.func,
};

export default ScheduleRequests;
